import { Link } from 'react-router-dom';
import { Mail, Phone, Pencil } from 'lucide-react';
import { ROUTES } from '@/constants/routes';
import { formatPhoneForDisplay } from '@/lib/phoneFormatter';

export function ContactPreview({ contact, editState }) {
  return (
    <div className="mx-auto mt-8 max-w-sm rounded-2xl border border-slate-200 bg-slate-50 p-5 text-left">
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold uppercase tracking-wider text-slate-500">
          We&apos;ll reach out at
        </p>
        <Link
          to={ROUTES.promotionContact}
          state={{ ...editState, isUpdate: true }}
          className="inline-flex cursor-pointer items-center gap-1 rounded-md px-2 py-1 text-xs font-semibold text-brand-700 transition-colors hover:bg-brand-50"
        >
          <Pencil className="size-3" aria-hidden="true" />
          Edit
        </Link>
      </div>
      <div className="mt-3 space-y-2.5">
        <div className="flex items-center gap-2.5 text-sm">
          <Mail className="size-4 shrink-0 text-brand-600" aria-hidden="true" />
          <span className="truncate font-semibold text-slate-900">
            {contact.email}
          </span>
        </div>
        <div className="flex items-center gap-2.5 text-sm">
          <Phone className="size-4 shrink-0 text-brand-600" aria-hidden="true" />
          <span className="font-semibold text-slate-900">
            {formatPhoneForDisplay(contact.phone)}
          </span>
        </div>
      </div>
    </div>
  );
}